module.exports = __webpack_public_path__ + "img/graph-image.e4012b28.png";